'use client';

import {
  Toast,
  ToastClose,
  ToastDescription,
  ToastProvider,
  ToastTitle,
  ToastViewport,
} from '@/components/ui/toast';
import { useToast } from '@/components/ui/use-toast';
import { ConfirmationIcon } from '@/components/icons/ConfirmationIcon';

export function Toaster() {
  const { toasts } = useToast();

  return (
    <ToastProvider>
      {toasts.map(function ({ id, title, description, action, ...props }) {
        if (!title && !description && !action) {
          return null;
        }
        return (
          <Toast key={id} {...props}>
            <div className="absolute left-5 rounded-md p-1 text-foreground/50 opacity-0 transition-opacity text-white">
              <ConfirmationIcon />
            </div>
            <div className="grid">
              {title && <ToastTitle>{title}</ToastTitle>}
              {description && (
                <ToastDescription>{description}</ToastDescription>
              )}
            </div>
            {action}
            <ToastClose />
          </Toast>
        );
      })}
      <ToastViewport />
    </ToastProvider>
  );
}
